import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { useDispatch } from 'react-redux';
import { UnknownAction } from '@reduxjs/toolkit';
import Line from '../../../../shared/components/line/index';
import { BMICard } from '../../../../shared/components/bmiCard/index';
import LightBlueCard from '../../../../shared/components/lightBlueCard/index';
import BmiIcon from '../../../../assets/icons/Icon_Improve Treatment_Large_White.svg';
import { SingleNumberCard } from '../../../../shared/components/numberInput/numberCards/singleNumberCard';

export const PALInput = ({
  BMRVal,
  activityFactorPAL_Input,
  setActivityFactorPAL_Input
}: {
  BMRVal: number;
  activityFactorPAL_Input: {
    PALRatio: number;
    value: number;
    bmrPlusPALInput: number;
  };
  setActivityFactorPAL_Input: (val: {
    PALRatio: number;
    value: number;
    bmrPlusPALInput: number;
  }) => UnknownAction;
}) => {
  const dispatch = useDispatch();
  const PALInput = React.useMemo(() => {
    return Number(((activityFactorPAL_Input.PALRatio - 1) * BMRVal).toFixed(2));
  }, [BMRVal, activityFactorPAL_Input.PALRatio]);

  useEffect(() => {
    const bmrPALValue = Number((BMRVal + PALInput).toFixed(2));
    dispatch(
      setActivityFactorPAL_Input({
        ...activityFactorPAL_Input,
        bmrPlusPALInput: bmrPALValue
      })
    );
  }, [BMRVal, PALInput]);

  return (
    <Box
      sx={{
        display: 'flex',
        gap: '1.875rem',
        flexDirection: 'column',
        marginTop: '1.875rem'
      }}
    >
      <Box
        sx={{
          border: '0.0625rem solid #D9D9D6',
          borderRadius: '0.9375rem',
          width: '100%',
          textAlign: 'center'
        }}
      >
        <SingleNumberCard
          width={'100%'}
          title={'PAL RATIO'}
          marginVal={'0.625rem'}
          range={{ min: 1.0, max: 2.5 }}
          incrementDecrementVal={0.1}
          value={activityFactorPAL_Input.PALRatio}
          setValue={(val: number) =>
            dispatch(
              setActivityFactorPAL_Input({
                ...activityFactorPAL_Input,
                PALRatio: val
              })
            )
          }
        />
      </Box>
      <Line color="#D9D9D6" width="100%" height="0.0625rem" />
      <LightBlueCard label={`PAL (kcal):`} value={`+ ${PALInput}`} />
      <BMICard
        label1="BMR + PAL"
        label2={`${activityFactorPAL_Input.bmrPlusPALInput} kcal`}
        icon={BmiIcon}
      />
    </Box>
  );
};
